import React, { Fragment } from 'react';
import { Link } from 'gatsby';
import ConditionalWrapper from '../ConditionalWrapper';
import MarkdownContent from '../MarkdownContent';

export default function ColumnContent(props) {
	const { link, title, content, figure } = props;
	return (
		<Fragment>
			<ConditionalWrapper
				condition={link}
				wrapper={(children) => (
					<Link to={link} aria-label={title}>
						{children}
					</Link>
				)}
			>
				<figure>{figure}</figure>
			</ConditionalWrapper>

			<h2>
				<ConditionalWrapper
					condition={link}
					wrapper={(children) => (
						<Link to={link} aria-label={title}>
							{children}
						</Link>
					)}
				>
					{title}
				</ConditionalWrapper>
			</h2>
			<div>
				<MarkdownContent>{content}</MarkdownContent>
			</div>
		</Fragment>
	);
}
